<template>
  <div class="d-flex flex-column flex-column-fluid flex-lg-row login" :style="'background-image: url('+require('@/assets/media/auth/bg.svg')+');'">
    <div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
      <div class="d-flex flex-center flex-lg-start flex-column">
        <span class="mb-7">
          <img alt="Logo" class="h-75px" :src="require('@/assets/media/logos/esklogo.svg')">
        </span>
      </div>
    </div>
    <div class="d-flex flex-center p-12 p-lg-20">
      <router-view/>
    </div>
    <custom-notification/>
  </div>
</template>
<script>
import CustomNotification from "@/components/Main/CustomNotification.vue";

  export default {
    name: 'AuthLayout',
    components: {CustomNotification}
  }
</script>
<style scoped>
  .login {
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
</style>